import enGB from './en-gb';
import plPL from './pl-pl';
import deDE from './de-de';

export default {
  'en-gb': enGB,
  pl: plPL,
  de: deDE
};
